
























// vue
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

// components
import BasePaginatorHoc from '@/components/base/BasePaginatorHoc.vue';
import GroupsRolesAndExceptionsList from '@/views/RolesAndPermissions/components/GroupsRolesAndExceptionsList.vue';
import RoleExceptionFilterActionComponent from '@/views/RolesAndPermissions/components/RoleExceptionFilterActionComponent.vue';

// store
import {
  GetRolesAndExceptionsParams,
  PaginatedUserGroupsPermissions,
  GroupPermissions,
  RoleGroupInfo
} from '@/store/modules/role/types/role.types';
import { RootState } from '@/store/store';
import { SortOrder, PaginatorSpecs } from '@/store/types/general.types';
import { RoleExceptionFilter } from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';

@Component({
  components: {
    GroupsRolesAndExceptionsList,
    BasePaginatorHoc,
    RoleExceptionFilterActionComponent
  }
})
export default class GroupTab extends Vue {
  page: number = 1;
  perPage: number = 10;
  search: string = '';
  role: string = '';
  exception: string | null = '';
  totalCount: number = 0;
  sortOrder: SortOrder = SortOrder.ASC;
  groups: RoleGroupInfo[] = [];
  selectedFilterOption: RoleExceptionFilter = {
    search: '',
    role: '',
    exception: '',
    displayExceptionName: ''
  };

  get GroupsRolesAndExceptionsList() {
    return GroupsRolesAndExceptionsList;
  }

  @Action('role/getGroupRolesAndExceptions')
  private getGroupRolesAndExceptions!: (
    payload: GetRolesAndExceptionsParams
  ) => Promise<void>;

  @State(({ role }: RootState) => role.groupRolesAndExceptions)
  private groupRolesAndExceptions!: PaginatedUserGroupsPermissions;

  @State(
    ({ role }: RootState) => role.apiState.getGroupRolesAndExceptions.success
  )
  private getGroupRolesAndExceptionsSuccessState!: boolean;

  @Watch('getGroupRolesAndExceptionsSuccessState')
  onGetGroupRolesAndExceptionsSuccessState() {
    if (!this.getGroupRolesAndExceptionsSuccessState) {
      if (this.groups.length > 0) {
        this.groups = [];
      }
      return;
    }

    if (
      !this.groupRolesAndExceptions ||
      this.groupRolesAndExceptions.itemCount === 0 ||
      !this.groupRolesAndExceptions.data ||
      this.groupRolesAndExceptions.data.length === 0
    ) {
      if (this.groups.length > 0) {
        this.groups = [];
      }
      if (this.totalCount !== 0) {
        this.totalCount = 0;
      }
      return;
    }

    const newTotalCount = +this.groupRolesAndExceptions.totalItems;
    if (this.totalCount !== newTotalCount) {
      this.totalCount = newTotalCount;
    }

    const newGroups: RoleGroupInfo[] = [];
    const groupsData: GroupPermissions[] = this.groupRolesAndExceptions
      .data as GroupPermissions[];

    groupsData.map((group) => {
      const roles: string[] = [];
      const exceptions: string[] = [];

      for (const permission of group.permissions) {
        if (permission.roleName && permission.type === 'role') {
          if (roles.indexOf(permission.roleName) === -1) {
            roles.push(permission.roleName);
          }
        }
        if (permission.groupPermission) {
          const permissionName: string = permission.groupPermission;
          if (permission.type === 'exception') {
            if (exceptions.indexOf(permissionName) === -1) {
              exceptions.push(permissionName);
            }
          }
        }
      }

      newGroups.push({
        id: group.id,
        name: group.name,
        roles,
        exceptions
      });
    });

    // Only update groups if the data has actually changed
    if (JSON.stringify(this.groups) !== JSON.stringify(newGroups)) {
      this.groups = newGroups;
    }
  }

  mounted() {
    this.sortOrder = SortOrder.ASC;
    this.getGroupRolesAndExceptionsHandler();
  }

  paginateItems({ perPage, page }: PaginatorSpecs): void {
    this.perPage = perPage;
    this.page = page;
    this.getGroupRolesAndExceptionsHandler();
  }

  public handleSort(data: any) {
    this.sortOrder = data.sortOrder;
    this.getGroupRolesAndExceptionsHandler();
  }

  public handleFilter(filter: RoleExceptionFilter) {
    this.page = 1;
    this.search = filter.search;
    this.role = filter.role;
    this.exception = filter.exception;
    this.getGroupRolesAndExceptionsHandler();
  }

  public handleResetFilter() {
    this.selectedFilterOption = {
      search: '',
      role: '',
      exception: '',
      displayExceptionName: ''
    };
    this.search = '';
    this.role = '';
    this.exception = '';
    this.getGroupRolesAndExceptionsHandler();
  }

  getGroupRolesAndExceptionsHandler() {
    const payload: GetRolesAndExceptionsParams = {
      page: this.page,
      limit: this.perPage,
      search: `%${this.search}%`,
      role: this.role,
      exception: this.exception,
      sortOrder: this.sortOrder
    };
    this.getGroupRolesAndExceptions(payload);
  }
}
